// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__i4kRJ","unreadBadge":"styles_unreadBadge__2tWaL","modalContent":"styles_modalContent__19sTj","modal":"styles_modal__2j_HC"};